export const AppointmentStatus = {
    STAFF_CANCELLATION: '178550009',
    CUSTOMER_CANCELLATION: '3',
}